import React, {useEffect, useState} from 'react';

function SelectDropdown(props) {
  const {
    items,
    defaultText,
    currentSelectedValue,
    changeAction,
    id,
    label,
    name
  } = props;

  const selectId = id || label || name;

  const [selectedOption, setSelectedOption] = useState(currentSelectedValue);
  const [initialLoad, setInitialLoad] = useState(true);

  useEffect(() => {
    if (initialLoad) {
      if (currentSelectedValue !== selectedOption) {
        setSelectedOption(currentSelectedValue);
      }
      setInitialLoad(false);
    }
  }, [currentSelectedValue, selectedOption, initialLoad]);

  const dropdownOptions = (items) ? Object.values(items) : [];

  return (
    <div className="select-dropdown-container">
      <label htmlFor={selectId} className='sr-hide'>{label}</label>
      <select
        id={selectId}
        name={name}
        className="select-dropdown"
        value={selectedOption} onChange={(e) => {setSelectedOption(parseInt(e.target.value))}}
      >
        <option value={0}>{defaultText}</option>
        {dropdownOptions.map((option, idx) => (
          <option key={idx} value={option.id}>{option.name}</option>
        ))}
      </select>
      <div className="select-dropdown-button">
        <button className = 'tes-button' onClick={() => {changeAction(selectedOption)}}>Select</button>
      </div>
    </div>
  );
}

export default SelectDropdown;